var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningOutline = function SvgWarningOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.725 3.463 9.344 16.159a.667.667 0 0 1-.58 1H2.8a.667.667 0 0 1-.58-1l9.343-16.16a.67.67 0 0 1 1.16 0Zm-2.138-.565c.693-1.197 2.423-1.197 3.115 0l9.344 16.159c.692 1.197-.173 2.693-1.558 2.693H2.801c-1.384 0-2.25-1.496-1.557-2.693l9.343-16.16Zm2.545 11.234a.846.846 0 0 1-1.693 0V7.361a.846.846 0 0 1 1.693 0v6.771Zm.282 3.668a1.129 1.129 0 1 1-2.257 0 1.129 1.129 0 0 1 2.257 0Z",
    fill: "currentColor"
  })));
};
export default SvgWarningOutline;